import { axiosInstancev2 } from '../../utils/Axios/axiosInterceptorv2';

export const deskiesApi = {
  list: (cohortId) =>
    axiosInstancev2.get(`/cohorts/${cohortId}/deskies`).then((r) => r.data),
  regenerate: (cohortId) =>
    axiosInstancev2.post(`/cohorts/${cohortId}/deskies/regenerate`),
  hold: (cohortId) => axiosInstancev2.post(`/cohorts/${cohortId}/deskies/hold`),
  resume: (cohortId) =>
    axiosInstancev2.post(`/cohorts/${cohortId}/deskies/resume`),
  publish: (cohortId) =>
    axiosInstancev2.post(`/cohorts/${cohortId}/deskies/publish`),
  preview: (cohortId) =>
    axiosInstancev2
      .get(`/cohorts/${cohortId}/deskies/preview`)
      .then((r) => r.data),
  setExclusion: (studentId, excluded, reason) =>
    axiosInstancev2.patch(`/students/${studentId}/deskie-exclusion`, {
      excluded,
      reason,
    }),
  assignMbti: (studentId, mbtiType) =>
    axiosInstancev2.patch(`/students/${studentId}/mbti`, {
      mbti_type: mbtiType,
    }),
};
